import { initialState, initialMutations, initialActions } from "../common_store";

let iniState = {
    url_name: 'visa-requests'
};

iniState = {...initialState, ...iniState };

const getters = {
    reportLoading: state => state.loading,
    serverPagination: state => state.serverPagination
};

const actions = {...initialActions };

const mutations = {...initialMutations };

export default {
    namespaced: true,
    state: iniState,
    getters,
    actions,
    mutations
}